<div class="version-dialog">
  <div class="header">
    <div class="header-title">
      <img src="../../../../../../Content/css/Images/modify-settings.png" />
      <label>Entity version</label>
    </div>
    <div class="close-icon" (click)="closeVersionDialog()">
      <img src="../../../../../../Content/css/Images/close-icon.png" />
    </div>

    <h3>Version comparision</h3>
  </div>
  <div class="ver-dialog-content">
    <div class="search-form" style="display: none;">
      From <input type="date" ngModel="dateFrom" /> To <input type="date" ngModel="dateTo" /> <button>Search
    version</button>
  </div>

  <div class="comparision">
    <div class="version-list">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Version</th>
            <th>Published by</th>
          </tr>
        </thead>
        <tbody>
          @for (version of versions; track version) {
            <tr>
              <td><input type="checkbox" [checked]="selectedVersion!=null && selectedVersion.Id == version.Id"
              (change)="setSelectedVersion(version,$event)" /></td>
              <td>
                <span>
                  {{formatDate(version.StartDate)}}
                </span>
              </td>
              <td>{{version.User.Username}}</td>
            </tr>
          }
        </tbody>
      </table>

    </div>
    @if (selectedVersion != null) {
      <div class="selected-version">
        <table>
          <thead>
            <tr>
              <th>
                Version comparision
                <div class="curr-ver-cmds">
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="cur-ver-td">
                <div class="scroll">
                  @if (comparisionLoading == true) {
                    <div class="loading-comparision">Loading...</div>
                  }
                  @if (comparisionLoading == false) {
                    <div>
                      <div class="curr-ver-title">
                        <p>Version published by <b>{{selectedVersion.User.Username}}</b> on
                        <b>{{formatDate(selectedVersion.StartDate)}}</b> </p>
                      </div>
                      @if (comparationResult!=null) {
                        <table>
                          <thead>
                            <tr>
                              <th>Field</th>
                              <th>
                                Old value
                              </th>
                              <th>
                                New value
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            @for (citem of comparationResult.ComparisionList; track citem) {
                              <tr>
                                <td>{{citem.Path}}</td>
                                <td>{{citem.OldValue}}</td>
                                <td>{{citem.NewValue}}</td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      }
                    </div>
                  }
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    }
  </div>
  @if (selectedVersion != null) {
    <div class="action-buttons">
      <button class="restore" (click)="restoreToVersion()">
        @if (restoringVersion == false) {
          <span>
            Restore
          </span>
        }
        @if (restoringVersion == true) {
          <span>
            Restoring...
          </span>
        }
      </button>
      <button class="cancel" (click)="closeVersionDialog()">Cancel</button>
    </div>
  }
</div>
<br style="clear: both;" />
</div>